import { configureStore as createToolkitStore } from '@reduxjs/toolkit';
import type { ThunkAction } from '@reduxjs/toolkit';
import type { AnyAction } from 'redux';

import type { RootState } from '../rootReducer';
import rootReducer from '../rootReducer';

const configureStore = (preloadedState?: RootState) => {
  const store = createToolkitStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ thunk: true, serializableCheck: false }),
    devTools: !import.meta.env.PROD,
  });

  if (import.meta.hot) {
    import.meta.hot.accept('../rootReducer', (nextRootReducer) => {
      if (nextRootReducer) {
        store.replaceReducer(nextRootReducer.default);
      }
    });
  }

  return store;
};

export type AppStore = ReturnType<typeof configureStore>;
export type AppDispatch = AppStore['dispatch'];
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  AnyAction
>;

export default configureStore;
